"use client"

import { Col, Row, Typography } from "antd"

const PrivacePolicyAndTermsConditions = ({ store }: any) => {

  const getPrivacyPolicyLink = () => {
    if (store.platform_name === "merchfans" || store.is_my_merch == 2) {
      return "https://merchfans.com/privacy-policy/"
    }

    switch (store.is_my_merch) {
      case 0:
        return "#"

      case 1:
        return "https://mymerchfactory.com/page-privacy.php"

      default:
        return "#"
    }
  }

  const getTermAndConditionLink = () => {
    if (store.platform_name === "merchfans" || store.is_my_merch == 2) {
      return "https://merchfans.com/terms-and-conditions/"
    }

    switch (store.is_my_merch) {
      case 0:
        return "#"

      case 1:
        return "https://mymerchfactory.com/page-terms.php"

      default:
        return "#"
    }
  }

  return (
    <Row wrap={false}>
      <Col style={{ marginRight: 10 }}>
        <Typography.Link href={getTermAndConditionLink()}>
          <Typography.Text>
            Privacy Policy
          </Typography.Text>
        </Typography.Link>
      </Col>

      <Col>
        <Typography.Link href={getPrivacyPolicyLink()}>
          <Typography.Text>
            Terms & Conditions
          </Typography.Text>
        </Typography.Link>
      </Col>
    </Row>
  )
}

export default PrivacePolicyAndTermsConditions